import React, { useEffect, useRef, useState } from 'react'
import { useDispatch, useSelector } from 'react-redux';
import { useNavigate } from "react-router-dom";
import { Helpers } from '../../../helpers/Helpers';
import { RootState } from '../../../redux/store';
import { MenuComponent } from '../../../_metronic/assets/ts/components';
import { KTCard } from '../../../_metronic/helpers/components/KTCard';
import { KTCardBody } from '../../../_metronic/helpers/components/KTCardBody';
import { KTIcon } from '../../../_metronic/helpers/components/KTIcon';
import Content from '../../../_metronic/layout/components/content/Content';
import { PageTitle } from '../../../_metronic/layout/core';
import toast from "react-hot-toast";
import { storeActivityIndicator, storeAreYouSureModalCallback, storeImageViewer } from '../../../redux/reducers/authSlice';
import { PersonnelService } from '../../../services/PersonnelService';
import { GetPersonnelListPagingAndFilterRequest, initialGetPersonnelListPagingAndFilterRequest } from '../../../models/request/personnel/GetPersonnelListPagingAndFilterRequest';
import TableFooter from '../../../components/TableFooter';
import { GetPersonnelListPagingAndFilterResponse, GetPersonnelListPagingAndFilterResponseData, GetPersonnelListPagingAndFilterResponseItem, initialGetPersonnelListPagingAndFilterResponseData } from '../../../models/response/personnel/GetPersonnelListPagingAndFilterResponse';
import { ColumnChooserModel } from '../../../models/common/ColumnChooserModel';
import { kolonlariBirlestir } from '../../../components/ColumnFilter/kolonBirlestir';
import { GetCompanyListResponse, GetCompanyListResponseItem } from '../../../models/response/company/GetCompanyListResponse';
import { CompanyService } from '../../../services/CompanyService';
import { CustomSingleSelectModel } from '../../../components/CustomSingleSelect';
import { GetConstantListResponse } from '../../../models/response/constant/GetConstantListResponse';
import { ConstantService } from '../../../services/ConstantService';
import { ToolbarWrapper } from '../../../_metronic/layout/components/toolbar';
import RefreshButton from '../../../components/RefreshButton';
import PersonnelListFilters from './Components/PersonnelListFilters';
import { ExportPersonnelListResponse } from '../../../models/response/personnel/ExportPersonnelListResponse';
import { DeletePersonnelResponse } from '../../../models/response/personnel/DeletePersonnelResponse';
import { useSortableColumns } from '../../../helpers/useSortableColumns';
import ColumnFilterRow from '../../../components/ColumnFilter/ColumnFilterRow';
import ColumnFilterChips from '../../../components/ColumnFilter/ColumnFilterChips';
import { ColumnFilterDefinitions } from '../../../components/ColumnFilter/ColumnFilterTypes';
import { loadConstants, loadConstantsByCode, YES_NO_FILTER } from '../../../components/ColumnFilter/columnFilterOptions';
import StatusBadge from '../../../components/StatusBadge';
import { ColumnFilterModel } from '../../../models/common/ColumnFilterModel';
import { buildExcelRequest, ExcelExportMode } from '../../../helpers/excelExportRequest';
import { personelUcretYetkisi } from '../../../services/PersonelUcretService';

const UCRET_KOLONLARI = ['guncelAylikMaas', 'guncelSaatlikUcret'];

const PersonnelList = () => {
    const navigate = useNavigate();
    const dispatch = useDispatch();
    const auth = useSelector((state: RootState) => state.auth)
    const pageName = "İnsan Kaynakları > Tanımlamalar > Personel Tanımları"
    const pageVersion = "1";
    // Maaş kolonları yalnız "Personel Ücretleri" yetkisi olana (backend de yetkisize boş döner).
    const ucretYetkisi = personelUcretYetkisi(auth.user.user?.data.authorizedMenus);
    const [data, setData] = useState<GetPersonnelListPagingAndFilterResponseData>(initialGetPersonnelListPagingAndFilterResponseData);
    const [filter, setFilter] = useState<GetPersonnelListPagingAndFilterRequest>(initialGetPersonnelListPagingAndFilterRequest)

    const getColumns = () => {
        var list: ColumnChooserModel[] = [];

        var str = localStorage.getItem(pageName + "-" + pageVersion + "-filters");

        list = [
            { title: 'Ad Soyad', name: 'nameSurname', order: 0, isVisible: true },
            { title: 'TC Kimlik No', name: 'tckn', order: 0, isVisible: true },
            { title: 'Telefon', name: 'phone', order: 0, isVisible: true },
            { title: 'E-Posta', name: 'email', order: 0, isVisible: true },
            { title: 'IBAN No', name: 'iban', order: 0, isVisible: true },
            { title: 'Banka Adı', name: 'bankName', order: 0, isVisible: true },
            { title: 'Döviz Cinsi', name: 'currencyTypeName', order: 0, isVisible: true },
            { title: 'Departman', name: 'departmentName', order: 0, isVisible: true },
            { title: 'Görevi', name: 'dutyName', order: 0, isVisible: true },
            ...(ucretYetkisi ? [
                { title: 'Aylık maaş', name: 'guncelAylikMaas', order: 0, isVisible: true, className: 'custom-text-right' },
                { title: 'Saatlik ücret', name: 'guncelSaatlikUcret', order: 0, isVisible: true, className: 'custom-text-right' },
            ] : []),
            { title: 'Aktif', name: 'isCustomActive', order: 0, isVisible: true },
            { title: 'Oluşturan', name: 'createdUser', order: 0, isVisible: true },
            { title: 'Güncelleyen', name: 'updatedUser', order: 0, isVisible: true }
        ];

        for (var i = 0; i < list.length; i++) {
            list[i].order = i + 1;
        }

        // Yetki sonradan kaldırıldıysa tarayıcıda kayıtlı düzendeki ücret kolonları da düşer.
        return kolonlariBirlestir(list, str).filter(x => ucretYetkisi || !UCRET_KOLONLARI.includes(x.name));
    }

    const [columns, setColumns] = useState<ColumnChooserModel[]>(getColumns());

    const performPagination = (i: number) => {
        getData({
            ...filter,
            currentPage: i,
            skip: (i - 1) * filter.take
        });
    }

    const changeTake = (_take: number) => {
        getData({
            ...filter,
            currentPage: 1,
            skip: 0,
            take: _take
        });
    }

    useEffect(() => {
        setTimeout(() => { MenuComponent.reinitialization() }, 1000)

        getData();
    }, [])

    const deletePersonnel = async () => {
        try {
            var selectedIds = data.items.filter(x => x.isSelected).map(x => x.personnelId);

            dispatch(storeActivityIndicator(true))

            var response: DeletePersonnelResponse = await PersonnelService.deletePersonnel(selectedIds);

            if (!response.isSuccess) {
                toast.error(response.message)
                dispatch(storeActivityIndicator(false))
                return;
            }

            toast.success(response.message)

            getData();
        } catch (error: any) {
            toast.error(error)
            dispatch(storeActivityIndicator(false))
        }
    }

    const updatePersonnel = async (_id: string | undefined = undefined) => {
        navigate('/personnel/listadd?id=' + (_id ? _id : data.items.filter(x => x.isSelected)[0].personnelId));
    }

    // Kolon filtresinde art arda istek gidebilir; yalnızca en son isteğin cevabı ekrana yazılır.
    const lastRequestNo = useRef(0);

    const getData = async (_filter: GetPersonnelListPagingAndFilterRequest | undefined = undefined) => {
        const requestNo = ++lastRequestNo.current;

        try {
            if (_filter)
                setFilter(_filter);
            else
                _filter = filter;

            dispatch(storeActivityIndicator(true))

            var response: GetPersonnelListPagingAndFilterResponse = await PersonnelService.getPersonnelListPagingAndFilter(_filter);

            if (requestNo != lastRequestNo.current)
                return;

            if (!response.isSuccess) {
                toast.error(response.message)
                return;
            }

            setData(response.data);
        } catch (error: any) {
            toast.error(error)
        }
        finally {
            // Daha yeni bir istek sürüyorsa yükleniyor göstergesi açık kalır.
            if (requestNo == lastRequestNo.current)
                dispatch(storeActivityIndicator(false))
        }
    }

    const setItemSelected = (_id: string) => {
        setData({
            ...data,
            items: data.items.map(function (x) {
                if (x.personnelId == _id)
                    x.isSelected = !x.isSelected;
                return x;
            })
        })
    }

    const selectAll = () => {
        var isAllSelected = data.items.filter(x => x.companyId).length == data.items.filter(x => x.companyId && x.isSelected).length;

        setData({
            ...data,
            items: data.items.map(function (x) {
                if (x.companyId)
                    x.isSelected = !isAllSelected;

                return x;
            })
        })
    }

    const onSearchSubmit = (e: any) => {
        e.preventDefault()
        getData();
    }

    const excelExport = async (mode: ExcelExportMode) => {
        try {
            dispatch(storeActivityIndicator(true))

            var response: ExportPersonnelListResponse = await PersonnelService.exportPersonnelList(buildExcelRequest(filter, mode, data.items.filter(x => x.isSelected).map(x => x.personnelId), columns));

            if (!response.isSuccess) {
                toast.error(response.message)
                return;
            }

            window.location.href = Helpers.getEndpoint() + "/Excels/" + response.data;
        } catch (error: any) {
            toast.error(error)
        }
        finally {
            dispatch(storeActivityIndicator(false))
        }
    }

    // Başlığa tıklayarak sıralanabilen kolonlar. Oluşturan/güncelleyen bilgisi listede yok.
    const sortableColumns = [
        'nameSurname', 'tckn', 'phone', 'email', 'iban',
        'bankName', 'currencyTypeName', 'departmentName', 'dutyName',
        'isCustomActive',
        ...(ucretYetkisi ? UCRET_KOLONLARI : [])
    ];

    const { thProps, sortArrow } = useSortableColumns(sortableColumns, filter, getData);

    // Kolon başlıklarının altındaki filtreler. Kolon adları backend'deki eşlemeyle
    // (PersonnelManager.ApplyColumnFilters) aynı.
    const columnFilterDefinitions: ColumnFilterDefinitions = {
        nameSurname: { type: 'text' },
        tckn: { type: 'text' },
        phone: { type: 'text' },
        email: { type: 'text' },
        iban: { type: 'text' },
        bankName: { type: 'select', loadOptions: () => loadConstants('BANK') },
        currencyTypeName: { type: 'select', loadOptions: () => loadConstantsByCode('CURRENCY') },
        departmentName: { type: 'select', loadOptions: () => loadConstants('COMPANY_DEPARTMENT') },
        dutyName: { type: 'select', loadOptions: () => loadConstants('PERSONNEL_DUTY') },
        isCustomActive: YES_NO_FILTER,
        createdUser: { type: 'text' },
        updatedUser: { type: 'text' },
        ...(ucretYetkisi ? {
            guncelAylikMaas: { type: 'number' as const },
            guncelSaatlikUcret: { type: 'number' as const },
        } : {}),
    };

    // Kolon filtresi değişince ilk sayfaya dönülür; sıralama ve sayfa boyu korunur.
    const changeColumnFilters = (columnFilters: ColumnFilterModel[]) => {
        getData({ ...filter, columnFilters: columnFilters, currentPage: 1, skip: 0 });
    }

    const getColumnValue = (item: GetPersonnelListPagingAndFilterResponseItem, column: string, index: number, className: string | undefined) => {
        if (column == "isCustomActive") {
            return (
                <td className={className} onClick={!item.companyId ? undefined : () => setItemSelected(item.personnelId)} onDoubleClick={!item.companyId ? undefined : () => updatePersonnel(item.personnelId)}><StatusBadge text={item.isCustomActive ? "Evet" : "Hayır"} /></td>
            )
        }
        else if (column == "createdUser") {
            return (
                <td className={className} onClick={!item.companyId ? undefined : () => setItemSelected(item.personnelId)} onDoubleClick={!item.companyId ? undefined : () => updatePersonnel(item.personnelId)}>{item.createdUser} - {item.createdDate}</td>
            )
        }
        else if (column == "updatedUser") {
            return (
                <td className={className} onClick={!item.companyId ? undefined : () => setItemSelected(item.personnelId)} onDoubleClick={!item.companyId ? undefined : () => updatePersonnel(item.personnelId)}>{item.updatedUser} - {item.updatedDate}</td>
            )
        }
        else if (UCRET_KOLONLARI.includes(column)) {
            var tutar: number | null | undefined = column == 'guncelAylikMaas' ? item.guncelAylikMaas : item.guncelSaatlikUcret;
            return <td className={className} onClick={!item.companyId ? undefined : () => setItemSelected(item.personnelId)} onDoubleClick={!item.companyId ? undefined : () => updatePersonnel(item.personnelId)}>{tutar != null ? Helpers.correctPrice(tutar, 2) : ''}</td>;
        }
        else {
            var item2: any = item;
            return <td className={className} onClick={!item.companyId ? undefined : () => setItemSelected(item.personnelId)} onDoubleClick={!item.companyId ? undefined : () => updatePersonnel(item.personnelId)}>{item2[column]}</td>;
        }
    }

    return (
        <React.Fragment>
            <ToolbarWrapper filters={<React.Fragment>
                <RefreshButton onClick={() => getData()} />
                <PersonnelListFilters
                    columns={columns}
                    excelExport={excelExport}
                    getColumns={getColumns}
                    pageName={pageName}
                    pageVersion={pageVersion}
                    setColumns={setColumns}
                    filter={filter}
                    getData={getData}
                    setFilter={setFilter}
                    selectedCount={data.items.filter(x => x.isSelected).length}
                    deleteFunction={deletePersonnel}
                    onSearchSubmit={onSearchSubmit}
                    updateFunction={updatePersonnel}
                />
            </React.Fragment>} />

            <PageTitle breadcrumbs={[{
                title: pageName.split('>').slice(0, pageName.split('>').length - 1).join(' > ') + ' > ',
                isActive: false,
                path: ''
            }]}>{(pageName.split('>')[pageName.split('>').length - 1])}</PageTitle>

            <Content>
                <KTCard className='mb-3'>
                    <KTCardBody className='py-2'>
                        <ColumnFilterChips
                            columns={columns}
                            definitions={columnFilterDefinitions}
                            filters={filter.columnFilters}
                            onChange={changeColumnFilters}
                        />

                        <div className='table-responsive new-table-container'>
                            <table id='kt_table_users' className='table align-middle table-row-dashed dataTable no-footer ebbe-compact-table'>
                                <thead>
                                    <tr className='text-start text-muted fw-bolder text-uppercase'>
                                        <th style={{ width: 1 }}>
                                            <div className='d-flex'>
                                                <label className='form-check form-check-sm form-check-custom form-check-solid me-5'>
                                                    <input onChange={selectAll} className='form-check-input' type='checkbox' checked={data.items.filter(x => x.isSelected).length > 0 && data.items.filter(x => x.isSelected).length == data.items.filter(x => x.companyId).length} />
                                                </label>
                                            </div>
                                        </th>

                                        {
                                            columns.filter(x => x.isVisible).sort(function (a, b) { return a.order - b.order; }).map((item, index) =>
                                                <th {...thProps(item.name)}>
                                                    {item.title}
                                                    {sortArrow(item.name)}
                                                </th>
                                            )
                                        }
                                    </tr>

                                    <ColumnFilterRow
                                        columns={columns.filter(x => x.isVisible).sort(function (a, b) { return a.order - b.order; })}
                                        definitions={columnFilterDefinitions}
                                        filters={filter.columnFilters}
                                        onChange={changeColumnFilters}
                                        leadingCellCount={1}
                                    />
                                </thead>
                                <tbody className='text-gray-600 fw-bold'>
                                    {
                                        data.items.length == 0 && (
                                            <tr>
                                                <td className="text-center" colSpan={99}>Kayıt bulunamadı.</td>
                                            </tr>
                                        )
                                    }
                                    {
                                        data.items.map((item, index) =>
                                            <tr style={{ background: item.isSelected ? 'rgba(204, 204, 204, 0.25)' : undefined }}>
                                                <td style={{ width: 1 }}>
                                                    {
                                                        item.companyId && (
                                                            <div className='d-flex'>
                                                                <label className='form-check form-check-sm form-check-custom form-check-solid me-5'>
                                                                    <input onChange={() => setItemSelected(item.personnelId)} className='form-check-input' type='checkbox' checked={item.isSelected} />
                                                                </label>
                                                            </div>
                                                        )
                                                    }
                                                </td>

                                                {
                                                    columns.filter(x => x.isVisible).sort(function (a, b) { return a.order - b.order }).map((column, columnIndex) => (
                                                        <React.Fragment>{getColumnValue(item, column.name, index, column.className)}</React.Fragment>
                                                    ))
                                                }
                                            </tr>
                                        )
                                    }
                                </tbody>
                            </table>
                        </div>
                    </KTCardBody>

                    <TableFooter
                        changeTake={changeTake}
                        take={filter.take}
                        currentPage={filter.currentPage}
                        performPagination={performPagination}
                        totalPageCount={Math.ceil(data.totalRecordCount / filter.take)}
                        totalRecordCount={data.totalRecordCount}
                        selectedCount={data.items.filter(x => x.isSelected).length}
                    />
                </KTCard>
            </Content>
        </React.Fragment>
    )
}

export default PersonnelList;